export enum LoanUsesVariation {
  Default = 'default',
  Carousel = 'carousel',
}
